/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 * check table get list from elastic search
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import { TableES } from '@modules/table/constants';

export function checkESTableList(listUrl: string): boolean {
    return Object.values(TableES).includes(listUrl);
}
